import { render, staticRenderFns } from "./test-service.vue?vue&type=template&id=5629e5db&scoped=true"
import script from "./test-service.vue?vue&type=script&lang=js"
export * from "./test-service.vue?vue&type=script&lang=js"
import style0 from "./test-service.vue?vue&type=style&index=0&id=5629e5db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5629e5db",
  null
  
)

export default component.exports